export const newPoint = {
  " De onde você está trabalhando hoje?": "¿Desde dónde estás trabajando hoy?",
  "Casa": "Casa",
  "Escritório": "Oficina",
  "Outro": "Otro",
  "Selecione o motivo do ponto por exceção": "Seleccione el motivo del registro de tiempo por excepción",
  "Selecione em que local você está": "Seleccione en qué lugar se encuentra",
  "Marcar Ponto": "Fichar",
  "Último ponto": "Último Fichaje",
  "Ponto em processamento": "Fichaje en proceso",
  "Seu ponto das": "Su fichaje de las",
  "já foi registrado!": "ya ha sido registrado!",
  "Atualize a página para visualizar o ponto.": "Actualice la página para ver el fichaje.",
  "Atualizar página": "Actualizar página",
  "Horas trabalhadas": "Horas trabajadas",
  "Seu turno está registrado como ": "Su turno está registrado como ",
  "Você não interagiu com essa página por mais de 2 minutos. Clique no botão para atualizar a página.": "No ha interactuado con esta página durante más de 2 minutos. Haga clic en el botón para actualizar la página.",
  "Houve um registro a menos de 5 minutos ": "Hubo un registro hace menos de 5 minutos ",
  "Você possui um afastamento hoje:": "Tiene una ausencia hoy:",
  "Tem certeza que deseja marcar seu ponto": "¿Está seguro de que desea registrar su fichaje?",
  "Selecione qual ponto você deseja marcar:": "Seleccione qué fichaje desea registrar:",
  "Entrada": "Entrada",
  "Saída intervalo": "Salida a descanso",
  "Volta intervalo": "Vuelta del descanso",
  "Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?": "Su último fichaje fue una entrada, ¿está seguro de que desea registrarlo de nuevo?",
  "Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?": "Su último fichaje fue una salida a descanso, ¿está seguro de que desea registrarlo de nuevo?",
  "Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?": "Su último fichaje fue una vuelta del descanso, ¿está seguro de que desea registrarlo de nuevo?",
  "Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?": "Su último fichaje fue una salida, ¿está seguro de que desea registrarlo de nuevo?",
  "Cancelar": "Cancelar",
  "Confirmar": "Confirmar",
  "Selecione o local que você está para marcar seu ponto.": "Seleccione el lugar en el que se encuentra para registrar su fichaje.",
  "Selecione o motivo do ponto por exceção para marcar seu ponto.": "Seleccione el motivo del registro de tiempo por excepción para registrar su fichaje.",
  "Aguarde um instante que logo seu ponto será confirmado!": "¡Espere un momento, su fichaje se confirmará pronto!",
  "Usuário rejeitou a solicitação de Geolocalização.": "El usuario rechazó la solicitud de geolocalización.",
  "Webcam not supported on this browser": "La cámara web no es compatible con este navegador",
  "Registro de ponto": "Registro de fichaje",
  "Parece que você ficou ausente": "Parece que ha estado ausente",
  "Marcar ponto novamente?": "¿Registrar el fichaje de nuevo?",
  "Sim, continuar": "Sí, continuar",
  "Marcar ponto em afastamento": "Registrar fichaje en ausencia"
};


// WEBPACK FOOTER //
// ./src/resources/es/newPoint.js